<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row>
          <!-- Duplicate spacial view parameter in order to put it before other menus -->
          <v-col v-if="ui.typeTab.selectedTab >= ui.typeTab.tabEnum.cameraTab" cols="12">
            <v-row v-if="ui.typeTab.selectedTab == 1">
              <v-col class="d-flex" cols="12" sm="3">
                <v-select
                  v-model="ui.deck.selectedDeck"
                  :items="ui.deck.deckList"
                  label="Deck selection"
                  filled
                  dense
                />
              </v-col>
              <v-col class="d-flex" cols="12" sm="6">
                <v-tabs v-model="ui.typeTab.selectedDeckTab" @change="updateTable">
                  <v-tab>Camera Positions</v-tab>
                  <v-tab>Paint Regions</v-tab>
                </v-tabs>
              </v-col>
            </v-row>
          </v-col>
          <!-- End -->
          <v-col :cols="ui.typeTab.selectedTab == ui.typeTab.tabEnum.equipmentTab ? 12 : 12">
            <v-row>
              <v-expansion-panels
                v-if="ui.typeTab.selectedTab == ui.typeTab.tabEnum.cameraTab"
                v-model="defaultVisibleCollapsedLayers"
                cols="12"
                class="padding12"
                multiple
              >
                <v-expansion-panel>
                  <v-expansion-panel-header ref="porto" @click="onDeckMapFoldToggle">Deck map</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col style="transition: 0.3s" sm="12" :xl="computedOverlaySize" md="10">
                        <Overlay
                          :source="ui.spatial.deckResource"
                          :crosshairx="0"
                          :crosshairy="0"
                          :polygons="computedSpatialPolys"
                          @poly-hover="locationMouseOver"
                          @poly-selected="locationClicked"
                        />
                      </v-col>
                      <!-- Spatial Component and Horizontal toggler which controls vertical/horizontal view -->
                      <v-col loaded-if="(ui.typeTab.selectedTab>=ui.typeTab.tabEnum.cameraTab)" sm="12" xl="3" md="2">
                        <v-tooltip right>
                          <template #activator="{ on, attrs }">
                            <v-btn
                              class="displayNon"
                              v-bind="attrs"
                              color="secondary"
                              style="margin: 10px"
                              fab
                              x-small
                              dark
                              v-on="on"
                              @click="toggleOverlaySize"
                            >
                              <v-icon>mdi-arrow-top-left-bottom-right</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ overlaySize == overlaySizeEnum['large'] ? 'Smaller view' : 'Larger view' }}</span>
                        </v-tooltip>
                        <!-- SpatialViewParameter component -->
                        <SpatialViewParameter :ui="ui" />
                        <v-col>Current point: {{ formatImageNameForDisplay(ui.spatial.hoverLocation) }}</v-col>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-col cols="12">
                <v-card>
                  <v-data-table
                    v-if="
                      activeTable.metricDefinitions &&
                      ui.typeTab.selectedTab == ui.typeTab.tabEnum.cameraTab &&
                      ui.typeTab.selectedDeckTab == ui.typeTab.deckPlanTab.cameraTab
                    "
                    dense
                    :loading="ui.dataTable.loading"
                    :headers="activeTableHeaders4CamAndReg"
                    :items="computedCameraTableRes"
                    :loading-text="getLoadingText()"
                    :items-per-page="20"
                    :footer-props="{
                      'items-per-page-options': [10, 20, 30, 40, 50, -1],
                    }"
                  >
                    <template #body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.name" @mouseover="locationMouseOver(item.location, item)">
                          <td>
                            <a
                              v-if="
                                ui.typeTab.selectedTab == ui.typeTab.tabEnum.cameraTab &&
                                ui.typeTab.selectedDeckTab == ui.typeTab.deckPlanTab.cameraTab
                              "
                              style="padding-right: 1em; text-decoration: none"
                              @click="locationClickedImage(item)"
                            >
                              {{ formatImageNameForDisplay(item.location) }}
                            </a>
                            <span
                              v-if="
                                ui.typeTab.selectedTab == ui.typeTab.tabEnum.cameraTab &&
                                ui.typeTab.selectedDeckTab == ui.typeTab.deckPlanTab.regionTab
                              "
                              style="padding-right: 1em; text-decoration: none"
                            >
                              {{ formatImageNameForDisplay(item.location) }}
                            </span>
                          </td>
                          <td>{{ item.deck }}</td>

                          <td v-for="corrosionLayer in corrosionLayersToDisplay" :key="corrosionLayer">
                            {{ item[corrosionLayer] }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                  <v-data-table
                    v-if="
                      activeTable.metricDefinitions &&
                      ui.typeTab.selectedTab == ui.typeTab.tabEnum.cameraTab &&
                      ui.typeTab.selectedDeckTab == ui.typeTab.deckPlanTab.regionTab
                    "
                    dense
                    :loading="ui.dataTable.loading"
                    :headers="activeTableHeaders4CamAndReg"
                    :items="computedRegionTableRes"
                    :loading-text="getLoadingText()"
                    :items-per-page="20"
                    :footer-props="{
                      'items-per-page-options': [10, 20, 30, 40, 50, -1],
                    }"
                  >
                    <template #body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.name" @mouseover="locationMouseOver(item.location, item)">
                          <td>
                            <a
                              v-if="
                                ui.typeTab.selectedTab == ui.typeTab.tabEnum.cameraTab &&
                                ui.typeTab.selectedDeckTab == ui.typeTab.deckPlanTab.cameraTab
                              "
                              style="padding-right: 1em; text-decoration: none"
                              @click="locationClickedImage(item)"
                            >
                              {{ formatImageNameForDisplay(item.location) }}
                            </a>
                            <span
                              v-if="
                                ui.typeTab.selectedTab == ui.typeTab.tabEnum.cameraTab &&
                                ui.typeTab.selectedDeckTab == ui.typeTab.deckPlanTab.regionTab
                              "
                              style="padding-right: 1em; text-decoration: none"
                            >
                              {{ formatImageNameForDisplay(item.location) }}
                            </span>
                          </td>
                          <td>{{ item.deck }}</td>

                          <td v-for="corrosionLayer in corrosionLayersToDisplay" :key="corrosionLayer">
                            {{ item[corrosionLayer] }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <!-- End -->
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="ui.typeTab.selectedTab == ui.typeTab.tabEnum.workPacksTab">
        <router-view name="WORK_PACK" @backBtnEvent="backBtnEvent" @routeUpdatedEvent="routeUpdatedEvent" />
      </v-col>
    </v-row>
    <Snackbar :type="snackBarType" :text="snackBarText" @onClose="handleSnackbarClose" />
  </v-container>
</template>

<script>
import { isEmpty } from 'lodash';
import MetricController from '@/controllers/MetricController';
import Overlay from '@/components/Overlay.vue';
import SpatialViewParameter from '@/components/widgets/SpatialViewParameter.vue';
import utils, { formatTableValueUnit, getAreaUnit, getDistanceUnit } from '@/utils';
import { Snackbar, notificationType } from '@/components/widgets';

const blankPlan = require('@/assets/blank_plan.png');

export default {
  name: 'DeckPlan',
  components: {
    Overlay,
    SpatialViewParameter,
    Snackbar,
  },
  props: {
    inspectionConfig: {
      type: Object,
      default: () => ({}),
    },
    snackBarType: {
      type: String,
      default: '',
    },
    snackBarText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      overlaySize: 1,
      overlaySizeEnum: {
        small: 0,
        regular: 1,
        large: 2,
      },
      defaultVisibleCollapsedLayers: [],
      collapsedLayers: {
        deckPlan: 0,
      },
      rawTableData: [],

      cameraTable: undefined,
      regionTable: undefined,

      ui: {
        typeTab: {
          selectedTab: 1,
          selectedDeckTab: undefined,
          tabEnum: {
            equipmentTab: 0,
            cameraTab: 1,
            workPacksTab: 2,
          },
          deckPlanTab: {
            cameraTab: 0,
            regionTab: 1,
          },
        },
        dataTable: {
          loading: false,
        },

        spatial: {
          hoverLocation: '',
          deckResource: blankPlan,
        },

        deck: {
          deckList: ['All'],
          selectedDeck: 'All',
        },
        // End
        spatialFilter: {
          activeMetric: 'AC-L',
          aggMethod: 'heatmap',
          metrics: {
            'AC-L': {
              text: 'AC-L',
              max: 0,
            },
          },
          markerScale: 4,
          threshold: 0.01,
          thresholdMax: 0,
          thresholdDisabled: false,
          color: 'primary',
        },
      },

      metricChartCount: 0,
      metricTables: {
        image: {
          columnDefs: [
            { text: 'Location', align: 'left', value: 'location' },
            { text: 'Deck', value: 'deck' },
            // { text: 'AC-L %', value: 'AC-L' },
            // { text: 'AC-M %', value: 'AC-M' },
            // { text: 'AC-H %', value: 'AC-H' },
          ],
        },
      },

      activeTable: {
        metricDefinitions: undefined,
        cameraAndRegionHeaders: undefined,
      },
      distanceMetrics: [],
      areaMetrics: [],
      corrosionLayers: {},
    };
  },

  computed: {
    // apply distance/area unit conversions for table metrics
    computedCameraTableRes() {
      if (!this.cameraTable) return;
      return this.computeTableValueUnit(this.cameraTable);
    },
    computedRegionTableRes() {
      if (!this.regionTable) return;
      return this.computeTableValueUnit(this.regionTable);
    },

    computedOverlaySize() {
      switch (this.overlaySize) {
        case this.overlaySizeEnum.small:
          return 7;
        case this.overlaySizeEnum.regular:
          return 7;
        case this.overlaySizeEnum.large:
          return 9;
        default:
          return 9;
      }
    },

    computedSpatialPolys() {
      Math.clamp = function (number, min, max) {
        return Math.max(min, Math.min(number, max));
      };
      let filtered;

      if (
        this.cameraTable &&
        this.ui.typeTab.selectedTab === this.ui.typeTab.tabEnum.cameraTab &&
        this.ui.typeTab.selectedDeckTab === this.ui.typeTab.deckPlanTab.cameraTab
      ) {
        try {
          filtered = this.cameraTable.filter((x) => x.deckResource === this.ui.spatial.deckResource);
        } catch (error) {}
      } else if (
        this.regionTable &&
        this.ui.typeTab.selectedTab === this.ui.typeTab.tabEnum.cameraTab &&
        this.ui.typeTab.selectedDeckTab === this.ui.typeTab.deckPlanTab.regionTab
      ) {
        try {
          filtered = this.regionTable.filter((x) => x.deckResource === this.ui.spatial.deckResource);
        } catch (error) {}
      } else {
        filtered = [];
      }
      return filtered.map((x) => {
        let size_px = this.ui.spatialFilter.markerScale;
        let col = 'rgba(0,0,0,0.5)';
        let strokeCol = 'black';
        let strokeWidth = 1;

        if (this.ui.spatialFilter.aggMethod === 'threshold') {
          if (x.metrics.coverage && x.metrics.coverage[this.ui.spatialFilter.activeMetric]) {
            if (x.metrics.coverage[this.ui.spatialFilter.activeMetric].mean > this.ui.spatialFilter.threshold) {
              col = 'rgba(255,0,0,0.5)';
            }
          }
        }

        if (this.ui.spatialFilter.aggMethod === 'heatmap') {
          if (x.metrics.coverage && x.metrics.coverage[this.ui.spatialFilter.activeMetric]) {
            const range = 90;
            const start = 250;
            col = `hsla(${
              start +
              Number(
                Math.clamp(
                  x.metrics.coverage[this.ui.spatialFilter.activeMetric].mean / this.ui.spatialFilter.thresholdMax,
                  0,
                  1
                )
              ) *
                range
            }, 100%, 50%, 0.5)`;
          }
        }

        // if (this.ui.spatial.hoverLocation == x.location) { col = "rgba(0,0,255,0.5)"}
        if (this.ui.spatial.hoverLocation === x.location) {
          strokeCol = 'orange';
          strokeWidth = 2;
        }

        size_px = this.ui.spatial.hoverLocation === x.location ? size_px * 2 : size_px;
        if (x.imagePlanInfo) {
          const p1 = x.imagePlanInfo[0].position;
          const remapped = [
            [p1[0] - size_px, p1[1] - size_px], // top left
            [p1[0] + size_px, p1[1] - size_px], // top right
            [p1[0] + size_px, p1[1] + size_px], // bottom right
            [p1[0] - size_px, p1[1] + size_px], // bottom left
          ];
          return {
            id: x.location,
            points: remapped,
            color: col,
            strokeColor: strokeCol,
            strokeWidth,
          };
        }
        return {
          id: x.location,
          points: x.polygons[0].points,
          color: col,
          strokeColor: strokeCol,
          strokeWidth,
        };
      });
    },

    activeTableHeaders4CamAndReg() {
      return (this.activeTable.cameraAndRegionHeaders || []).slice().map((h) => {
        if (this.distanceMetrics.includes(h.value))
          return { ...h, text: `${h.text} (${getDistanceUnit(this.$store.state.unit)})` };
        if (this.areaMetrics.includes(h.value))
          return { ...h, text: `${h.text} (${getAreaUnit(this.$store.state.unit)})` };
        return h;
      });
    },

    corrosionLayersToDisplay() {
      const layersToDisplay = [];
      const layers = Object.keys(this.corrosionLayers);
      layers.forEach((iterator) => {
        if (this.corrosionLayers[iterator].inspectionViewDisplay.display) {
          layersToDisplay.push(iterator);
        }
      });
      return layersToDisplay;
    },
    currentWindowResolution() {
      return utils.getWindowResolution();
    },
  },

  watch: {
    'ui.deck.selectedDeck': async function () {
      this.ui.dataTable.loading = true;
      try {
        await this.updateSearchImage();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.ui.dataTable.loading = false;
      }
    },
  },

  beforeMount() {
    this.initialise();
  },

  mounted() {
    this.defaultVisibleCollapsedLayers.push(this.collapsedLayers.deckPlan);
  },

  methods: {
    formatImageNameForDisplay: utils.formatImageNameForDisplay,
    async initialise() {
      try {
        this.corrosionLayers = this.inspectionConfig.corrosionLayers;
        this.areaMetrics = this.inspectionConfig.areaMetrics;
        const layers = Object.keys(this.corrosionLayers);
        layers.forEach((iterator) => {
          if (this.corrosionLayers[iterator].inspectionViewDisplay.display) {
            const existedInHeader = this.metricTables.image.columnDefs.find(({ value }) => value === iterator);
            if (!existedInHeader) {
              this.metricTables.image.columnDefs.push({
                text: this.corrosionLayers[iterator].inspectionViewDisplay.imageColumnDefsText,
                value: iterator,
              });
            }
          }
          this.ui.spatialFilter.metrics[iterator] = {
            text: iterator,
            max: this.corrosionLayers[iterator].spatialFilter.metricsMax,
          };
        });
        return this.updateTable();
      } catch (error) {
        console.log(error);
        this.handleError(error);
        return undefined;
      }
    },

    locationMouseOver(location, item) {
      this.ui.spatial.hoverLocation = location;
      if (item) {
        this.ui.spatial.deckResource = item.deckResource;
      }
    },

    locationClicked(location) {
      const imageId = this.rawTableData.find((x) => x.location === location)?.id;
      if (imageId) {
        this.$router.push({ path: `/spherical?id=${this.$route.query.id}&image=${imageId}` }, () =>
          window.location.reload()
        );
      } else {
        this.handleError(`Location was not found: ${location}`);
      }
    },

    async fetchImageLocations(id) {
      const { data } = await MetricController.getMetricChildren2(id, 'deck', 2, []);

      this.ui.deck.deckList = data.map(({ name }) => name);
      this.ui.deck.deckList.push('All');

      return this.fetchLocationsByRegion(data, 'image');
    },

    async fetchRegionLocations(id) {
      const { data } = await MetricController.getMetricChildren2(id, 'deck', 2, []);
      return this.fetchLocationsByRegion(data, 'paint region');
    },

    async fetchLocationsByRegion(data, region) {
      const locations = await Promise.all(
        data.map(({ _id: id }) => MetricController.getMetricChildren2(id, region, 2, []))
      );

      return data.map((deck, index) => ({
        ...deck,
        locations: locations[index].data,
      }));
    },

    // process/load asset table items
    async updateSearchImage() {
      const deckDetails = (deck) =>
        deck.locations.map(({ name, data, _id: id }) => {
          const corrosionLayers = Object.keys(this.corrosionLayers).reduce((layers, layer) => {
            // eslint-disable-next-line no-param-reassign
            layers[layer] = data.metrics.coverage?.[layer]?.mean.toFixed(4) || (0).toFixed(2);
            return layers;
          }, {});

          return {
            location: name.split('/').pop(),
            deck: deck.name,
            deckResource: deck.data.resource,
            imagePlanInfo: data.plan,
            id,
            metrics: data.metrics,
            ...corrosionLayers,
          };
        });

      this.activeTable.metricDefinitions = this.metricTables.image.columnDefs;
      this.activeTable.cameraAndRegionHeaders = this.metricTables.image.columnDefs;

      const { selectedDeck } = this.ui.deck;
      const locations = await this.fetchImageLocations(this.$route.query.id);
      const result = locations
        .filter((deck) => selectedDeck === 'All' || selectedDeck === deck.name)
        .map((deck) => {
          this.ui.spatial.deckResource = deck.data.resource;
          return deckDetails(deck);
        });

      [this.rawTableData] = result.slice(-1);
      this.cameraTable = result.flat();
    },

    async updateSearchRegions() {
      const deckDetails = (deck) =>
        deck.locations.map(({ name, data }) => {
          const corrosionLayers = Object.keys(this.corrosionLayers).reduce((layers, layer) => {
            // eslint-disable-next-line no-param-reassign
            layers[layer] = data.metrics.coverage?.[layer]?.mean.toFixed(4) || (0).toFixed(2);
            return layers;
          }, {});

          return {
            location: name.split('/').pop(),
            deck: deck.name,
            deckResource: deck.data.resource,
            imagePlanInfo: data.plan,
            metrics: data.metrics,
            polygons: data.polygons,
            ...corrosionLayers,
          };
        });

      this.activeTable.metricDefinitions = this.metricTables.image.columnDefs;
      this.activeTable.cameraAndRegionHeaders = this.metricTables.image.columnDefs;

      const locations = await this.fetchRegionLocations(this.$route.query.id);
      const result = locations.map(deckDetails);

      [this.rawTableData] = result;
      this.regionTable = result.flat();
    },

    // compute cached table metrics
    computeTableMetrics(table) {
      // compute max values for table
      Object.keys(this.ui.spatialFilter.metrics).forEach((metric) => {
        // pull out metric values from tableRes
        const metricValues = table
          .map((r) => r[metric])
          .filter((r) => r && !Number.isNaN(Number(r)))
          .map((r) => Number(r));

        // set threshold slider max as metric max
        this.ui.spatialFilter.metrics[metric].max = Math.max(...metricValues);
      });

      // check threshold disabled state
      const globalMax = Math.max(...Object.values(this.ui.spatialFilter.metrics).map(({ max }) => max));
      this.ui.spatialFilter.thresholdMax = globalMax;
      this.ui.spatialFilter.thresholdDisabled = !globalMax;
    },
    computeTableValueUnit(table) {
      return table
        .map(formatTableValueUnit(this.distanceMetrics, this.areaMetrics, this.$store.state.unit))
        .filter((x) => !isEmpty(x));
    },
    async updateTable() {
      this.ui.dataTable.loading = true;
      // reset table state
      // empty table res while table loading
      this.rawTableData = [];
      let success;
      try {
        if (this.ui.typeTab.selectedTab === this.ui.typeTab.tabEnum.cameraTab) {
          if (this.ui.typeTab.selectedDeckTab === this.ui.typeTab.deckPlanTab.cameraTab) {
            await this.updateSearchImage();
            this.computeTableMetrics(this.cameraTable);
            success = true;
          } else if (this.ui.typeTab.selectedDeckTab === this.ui.typeTab.deckPlanTab.regionTab) {
            await this.updateSearchRegions();
            this.computeTableMetrics(this.regionTable);
            success = true;
          }
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        if (success) {
          this.ui.dataTable.loading = false;
        }
      }
    },

    locationClickedImage(data) {
      window.open(`/spherical?id=${this.$route.query.id}&image=${data.id}`);
    },

    toggleOverlaySize() {
      if (this.overlaySize === this.overlaySizeEnum.regular) {
        this.overlaySize = this.overlaySizeEnum.large;
        this.scrollToDeckMap('porto');
      } else if (this.overlaySize === this.overlaySizeEnum.large) {
        this.overlaySize = this.overlaySizeEnum.regular;
      }
    },

    // table loading text
    getLoadingText() {
      return 'Loading data, please wait...';
    },

    scrollToDeckMap(refName) {
      const offSetTop = this.$refs[refName].$el.offsetParent.offsetParent.offsetTop;
      setTimeout(() => {
        window.scrollTo({ left: 0, top: offSetTop, behavior: 'smooth' });
      }, 200);
    },
    onDeckMapFoldToggle() {
      if (this.defaultVisibleCollapsedLayers.length === 0) {
        this.scrollToDeckMap('porto');
      }
    },
    backBtnEvent(_item) {},
    routeUpdatedEvent(_item) {},

    handleError(error) {
      this.displaySnackbar(error, notificationType.error);
    },

    displaySnackbar(message, type) {
      this.$emit('onSnackbarDisplay', message, type);
    },

    handleSnackbarClose() {
      this.$emit('onSnackbarClose');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.flexDisplay {
  display: flex;
  align-items: center;
}

.padding12 {
  padding: 12px;
  margin-top: -40px;
}

@media screen and (max-width: 1903px) {
  .displayNon {
    display: none;
  }
}
</style>
